import {Component, inject} from '@angular/core';
import {FormControl, FormGroup, Validators, ReactiveFormsModule} from "@angular/forms";
import {CustomerService} from "../../services/customer.service";
import {MatSnackBar} from "@angular/material/snack-bar";
import {FormElementComponent} from '../../../core/components/form-element/form-element.component';
import {PageBase} from "../../../core/components/page-base";

@Component({
  selector: 'app-forgotten-password',
  templateUrl: './forgotten-password.component.html',
  styleUrl: './forgotten-password.component.scss',
  imports: [ReactiveFormsModule, FormElementComponent],
})
export class ForgottenPasswordComponent extends PageBase {
  private customerService = inject(CustomerService);

  forgottenPasswordForm = new FormGroup({
    email: new FormControl('', [
      Validators.required,
      Validators.email,
    ]),
  });

  regeneratePassword(): void {
    if (this.forgottenPasswordForm.valid) {
      const email = this.forgottenPasswordForm.get('email')?.value ?? '';

      this.customerService.regeneratePassword(email).subscribe({
          next: resultJson => {
            if (resultJson?.success === true) {
              this.snackBar.open('Новата парола за този E-mail адрес е изпратена на Вашият E-mail!', '×', {
                horizontalPosition: 'center',
                verticalPosition: 'top',
                panelClass: 'success',
              });
            }
          },
          error: err => {
            this.snackBar.open('Няма регистриран потребител с посоченият E-mail адрес!', '×', {
              horizontalPosition: 'center',
              verticalPosition: 'top',
              panelClass: 'error',
            });
            console.log(err);
          },
        }
      );
    }
  }

  override ngOnInit(): void {
    this.pageTitle = "Забравена парола за интернет кредит от МиниЗаем. - Minizaem.bg";
    this.metaDescription = "Как да си генерирам нова парола за сайта minizaem.bg.";
    super.ngOnInit();
  }
}
